import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import { FullPageLoading } from '@Components';
import { AppDispatch, authorizationOperations, MiscellaneousActions } from '@Store';
import config from '../../config';

const Home = ({
  updateAuthenticationError,
  clearToken,
}: {
  updateAuthenticationError: (error: string) => void;
  clearToken: () => void;
}) => {
  const { logout, isLoading } = useAuth0();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');
  const errorDescription = searchParams.get('error_description');

  useEffect(() => {
    // The login redirect arrives with ?code=&state= in the URL. Auth0's SDK
    // needs to read those to finish logging the user in. If we navigate away
    // too soon, the URL (and that code/state) gets wiped before the SDK can
    // grab it — so the login silently fails and the user gets bounced back
    // to the login screen.
    //
    // isLoading is true while the SDK is still working on that, and flips to
    // false once it's done. So we just wait here until it's false before
    // moving on. (Not applied to the logyca flavor)
    if (!config.isLogycaFlavor && isLoading) {
      return;
    }

    if (!error) {
      navigate('/landing', { replace: true });
      return;
    }

    updateAuthenticationError(errorDescription || '');

    if (config.isLogycaFlavor) {
      clearToken();
      window.location.href = config.REACT_APP_LOGYCA_LOGIN_URL;
    } else {
      logout({ returnTo: `${window.location.origin}` });
    }

    // TODO log error
  }, [error, isLoading]);

  return <FullPageLoading />;
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  const { updateValue: dispatchUpdateValue } = MiscellaneousActions;
  const { clearToken } = authorizationOperations;

  return {
    updateAuthenticationError: (error: string) => dispatch(dispatchUpdateValue({ authenticationError: error })),
    clearToken: () => dispatch(clearToken()),
  };
};

export default connect(null, mapDispatchToProps)(Home);
